import * as actions from './actions';
import * as mutations from './mutations';
import * as getters from './getters';

const state = () => ({
    isFetching: false,
    allLibraryQuestions: [],
    selectedQuestion: null,
    questionHistory: [],
    allTags: [],
    allCategories: []
})

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
